import service from '@/components/Table/service'
import { onMounted, ref } from '@vue/composition-api'
import Vue from 'vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { createToastInterface } from 'vue-toastification'
import { serializeErrorMessage } from '@core/utils/utils'

export default function useOrder() {
	const normalizeOrder = data => {
		const order = data || {}
		const shipment = order.shipment || {}
		const transaction = order.transaction || {}
		const user = order.user || {}

		return {
			...order,
			transaction,
			shipment: {
				...shipment,
				shipment_price: shipment.shipment_price ?? shipment.price ?? 0,
				shipment_status:
					shipment.shipment_status ?? shipment.biteship_shipping_status ?? '-',
				payment_date: shipment.payment_date ?? shipment.biteship_delivery_date ?? null,
			},
			user,
			receiver: order.receiver
				? order.receiver
				: {
					name: shipment.receiver_name ?? '-',
					phone_number: shipment.receiver_phone ?? '-',
					label_address: shipment.type_address ?? '-',
					address: shipment.address ?? '-',
					district: shipment.district ?? '-',
					city: shipment.city ?? '-',
					provinsi: shipment.provinsi ?? shipment.province ?? '-',
					postal_code: shipment.postal_code ?? '-',
					note: shipment.note ?? '-',
				},
			items: Array.isArray(order.items) ? order.items : [],
			voucher_usage: order.voucher_usage ? order.voucher_usage : null,
		}
	}

	const resolveInvoiceStatusVariantAndIcon = status => {
		if (status === 'UNPAID') return { variant: 'warning', icon: 'XIcon' }
		if (status === 'Proses') return { variant: 'info', icon: 'PieChartIcon' }
		if (status === 'PAID') return { variant: 'success', icon: 'CheckCircleIcon' }
		return { variant: 'secondary', icon: 'XIcon' }
	}

	const isLoading = ref(false)

	const orderDetail = ref(null)

	const retrieveOrder = id => {
		isLoading.value = true
		service
			.show({ url: 'orders', id })
			.then(response => {
				if (response.status === 200) {
					orderDetail.value = normalizeOrder(response.data.data)
				}
			})
			.catch(error => {
				const element = Vue.component('description', {
					render: h => serializeErrorMessage(h, error),
				})
				const toast = createToastInterface({
					timeout: 6000,
				})
				toast({
					component: ToastificationContent,
					props: {
						title: 'Error Retrieve The Order',
						icon: 'AlertTriangleIcon',
						variant: 'danger',
						description: element,
					},
				})
			})
			.finally(() => {
				isLoading.value = false
			})
	}

	const calcTotal = item => {
		const total =
			(parseFloat(item.price) -
				parseFloat(item.price) * (parseFloat(item.discount) / 100)) *
			parseInt(item.quantity)
		return total
	}

	const subTotal = items => {
		let total = 0
		if (!Array.isArray(items)) {
			return total
		}

		items.forEach(item => {
			// const t =
			// 	(parseFloat(item.price) -
			// 		parseFloat(item.price) * (parseFloat(item.discount) / 100)) *
			// 	parseInt(item.quantity)
			const t = calcTotal(item)
			total += t
		})
		return total
	}

	const total = orderDetail => {
		if (!orderDetail) {
			return 0
		}

		let total = subTotal(orderDetail.items)
		let voucherValue =
			orderDetail.voucher_usage !== null
				? parseFloat(orderDetail.voucher_usage.value)
				: 0

		if (
			orderDetail.voucher_usage !== null &&
			orderDetail.voucher_usage.type === 'percentage'
		) {
			voucherValue = total - total * (voucherValue / 100)
		}
		total = total + parseFloat(orderDetail.shipment.shipment_price) - voucherValue
		return total
	}

	return {
		resolveInvoiceStatusVariantAndIcon,
		retrieveOrder,
		orderDetail,
		calcTotal,
		subTotal,
		total,
		isLoading,
	}
}
